import { CarFilled } from '@ant-design/icons';
import { useClickOutside } from '@evidia/components';
import { Dropdown } from 'antd';
import { useRef, useState } from 'react';
import { StyledCard } from '../StyledCard';
import arrow from './arrow.svg';
import { Arrows, DropdownContent, RadioGroup, RadioStyled, Title, ToggleSchool } from './styles';

export type Item = {
	id: string;
	label: string;
	isActive?: boolean;
};

type Props = {
	title?: string;
	isMobile?: boolean;
	items: Item[];
	select(id: string): void;
};

export const Switcher = ({ title, items, isMobile = false, select }: Props) => {
	const [isOpen, setIsOpen] = useState(false);
	const containerRef = useRef<HTMLDivElement>(null);

	useClickOutside(containerRef, () => {
		if (isOpen) {
			setIsOpen(false);
		}
	});

	const activeSchool = items.find(item => item.isActive);

	if (!activeSchool) {
		return null;
	}

	const selectOption = (id: string) => {
		select(id);
		setIsOpen(false);
	};

	const getDropdownRender = () => (
		<DropdownContent ref={containerRef}>
			{!isMobile && <Title>Autoškola</Title>}
			<RadioGroup onChange={e => selectOption(e.target.value)} value={activeSchool.id}>
				{items.map(item => (
					<RadioStyled value={item.id} key={item.id}>
						{item.label}
					</RadioStyled>
				))}
			</RadioGroup>
		</DropdownContent>
	);

	const switcher = (
		<Dropdown trigger={['click']} dropdownRender={getDropdownRender} open={isOpen}>
			<ToggleSchool
				$isMobile={isMobile}
				type="button"
				onClick={e => {
					e.preventDefault();
					setIsOpen(prev => !prev);
				}}
			>
				{!isMobile && <CarFilled />}
				<span>{activeSchool.label}</span>
				<Arrows>
					<img src={arrow} alt="arrow" />
					<img src={arrow} alt="arrow" />
				</Arrows>
			</ToggleSchool>
		</Dropdown>
	);

	if (isMobile) {
		return (
			<StyledCard $padding="1em">
				{title && isMobile && <Title $isMobile>{title}</Title>}
				{switcher}
			</StyledCard>
		);
	}

	return switcher;
};
